/**
 * 用于 校验当前 jsapi是否 真是错误 需要上报
 */
import Env from 'common/env.js';
var filterMap = {
    default:{
        isOK:function(res){
            var ret = res.err_msg + '';
            var ok = ( 
                        -1  !=  ret.indexOf(':ok') || 
                        '0' === res.result+'' );
            return ok;
        }
    },
    getInstallState:{
        isOK:function(res){
            var ret = res.err_msg + '';
            var ok = ( -1  !=  ret.indexOf(':yes') );
            return ok;
        }
    },
    
    operateGameCenterMsg:{
        /**
         * 查看 operateGameCenterMsg 是否成功的条件。
         * 只要有result 就认为成功。它没设计 result下，是否还有:ok之类的细节。
         * @param {*} res
         * @returns
         */
        isOK:function(res){
            if( undefined != res.result ){
                return true;
            }
            if( 'err_msg' in res ){
                var ret = res.err_msg + '';
                var ok = ( -1  !=  ret.indexOf(':ok') );
                return ok;
            }
            return false;
        }
    },

    webTransfer: {
        isOK: function(res) {
            if( Env.isAndroid ) {
                return res?.err_msg?.indexOf(":ok") > -1;
            }else {
                return res?.errCode === 0;
            }
        }
    }
};

const exported = {
    isOK:function(jsapiName,res){
        if( Env.isMiniprogram() ) {
            // 过滤掉小程序内嵌 webview 不支持的报错
            let errMsg = res?.err_msg || ''
            if( errMsg.indexOf("system:access_denied") > -1 ||
                errMsg.indexOf("system:function_not_exist") > -1 || 
                errMsg.indexOf("fail_no execute in current borwser") > -1
            ) {
                return true;
            }
        }
        if( jsapiName in filterMap ){
            return filterMap[jsapiName].isOK(res);
        }else{
            return filterMap['default'].isOK(res);
        }
    }
};

export default exported;

export const {
    isOK
} = exported;